<template>
  <div id="app">
    <router-view />
    <!-- 修改 -->
    <bottomCon v-show="hiddenOrdisplay" />
    <rightNav />
  </div>
</template>

<script>
import $ from "jquery";
import bottomCon from "./components/bottomCon";
import rightNav from "./components/rightNav";
export default {
  mounted() {
    setTimeout(() => {
      this.init();
    }, 3000);
  },
  components: {
    bottomCon,
    rightNav,
  },
  data() {
    return {
      hiddenOrdisplay: true,
    };
  },
  name: "App",
  watch: {
    // 修改
    $route: {
      //监听路由历史的变化
      handler(to, from) {
        this.hiddenOrdisplay = true;
        const path = [
          "/completion",
          "/examinatStart",
          "/examInstructions",
          "/systemRead",
          "/singleChoice",
          "/doubleChoice",
          "/singleChoiceBoolean",
          "forref",
          "learntest",
          "/examinContent/systemRead",
          "/explain",
          "resttime",
          "/examinContent/examinatStart",
          "/review",
          "/imageAnalysis",
          "/table",
          "/reasoning",
          "/choice"
        ];
        for (const item of path) {
          if (!this.hiddenOrdisplay || to.path.includes(item)) {
            this.hiddenOrdisplay = false;
          }
        }
      },
      immediate: true,
    },
  },
  methods: {
    init() {
      let $nb_icon_wrap = $("#nb_icon_wrap");
      let $nb_invite_wrap = $("#nb_invite_wrap");
      let $nb_nodeboard = $("#nb_nodeboard");
      $nb_invite_wrap.css({
        display: "none",
        visibility: "hidden",
      });
      $nb_icon_wrap.css({
        display: "none",
        visibility: "hidden",
      });
      $nb_nodeboard.css({
        display: "none",
        visibility: "hidden",
      });
    },
  },
};
</script>

<style>
* {
  padding: 0;
  margin: 0;
}

.xradio .el-radio__label {
  display: none;
}
.xradio.is-bordered {
  padding: 9px 10px 9px 10px;
  height: auto;
}
.xtable1 tbody .el-table__row > :first-child .cell {
  display: flex;
  align-content: center;
  justify-content: center;
}
.xtable1 tbody .el-table__row > :nth-child(2) .cell {
  display: flex;
  align-content: center;
  justify-content: center;
}
.xtable2 tbody .el-table__row > :first-child .cell {
  display: flex;
  align-content: center;
  justify-content: center;
}

/* 二段式分析 */
.doubleChoice .el-checkbox__label {
  display: none;
}
.doubleChoice .el-checkbox.is-bordered {
  padding: 9px 10px 9px 10px;
}

/* 表格题 */
.tableVue .el-radio__label {
  display: none;
}
.tableVue .el-radio.is-bordered {
  padding: 9px 10px 9px 10px;
  height: auto;
}
.el-table thead.is-group th {
  background: none !important;
}
img{
  max-width: 100% !important;
}

.el-table span{
  word-wrap:break-word !important; 
  word-break:keep-all !important; 
}
.el-table div{
  word-wrap:normal !important; 
  word-break:keep-all !important; 
}
.el-table  .cell{
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.el-table .sort-caret {
  left: 0 !important;
}

.el-table--enable-row-hover .el-table__body tr:hover > td {
   background-color: #FFF !important;
}
.hover-row > td{
  background-color: #FFF !important;
}
.el-table {  
  border-bottom: 1px solid #999;
  border-right: 1px solid #999;
}

.el-table th {
    border: 1px solid #999 !important;
    border-right: none !important;
    border-bottom: none !important;
}
 
.el-table td {
    border: 1px solid #999 !important;
    border-right: none !important;
    border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue